<template>
  <span :id="model?.system?.id">
    <SmartLinkItemComponent :id="model?.system?.id" :component="!model?.system?.workflow">
      <div class="container capability-list">
        <SmartLinkStandaloneElement :codename="type.elements.title.codename">
          <h2 class="capability-list__title">{{ data.title }}</h2>
        </SmartLinkStandaloneElement>
        <SmartLinkStandaloneElement :codename="type.elements.capabilities.codename">
          <div class="capability-list__wrapper">
            <div
              v-for="item in data.capabilities"
              :key="item.system.id"
              class="btn capability-list__btn h-auto"
            >
              <div class="capability-list__btn__wrapper" @click="openCapability(item)">
                <p class="title">
                  {{ item.elements.title.value }}
                </p>
                <IconCaretDown v-if="!isEmpty(item.elements.navLinkDescription.value)" />
              </div>
              <div
                v-if="!isEmpty(item.elements.navLinkDescription.value)"
                class="short-description"
              >
                <RichText :value="item.elements.navLinkDescription.value" />
              </div>

              <div
                v-if="!isEmpty(item.elements.navLinkDescription.value)"
                class="capability-list__btn__popover"
              >
                <div class="d-flex w-100 justify-content-between align-items-center">
                  <p class="title">
                    {{ item.elements.title.value }}
                  </p>
                  <IconCaretUp v-if="!isEmpty(item.elements.navLinkDescription.value)" />
                </div>
                <div
                  v-if="!isEmpty(item.elements.navLinkDescription.value)"
                  class="short-description"
                >
                  <RichText :value="item.elements.navLinkDescription.value" />
                </div>
              </div>
            </div>
          </div>
        </SmartLinkStandaloneElement>
      </div>
    </SmartLinkItemComponent>
  </span>
</template>
<script lang="ts" setup>
import type { CapabilitiesPageModel, CapabilityListModel } from '~/models'
import { contentTypes } from '~/models'
const type = contentTypes.capability_list

const pageStore = usePageStore()
const props = defineProps<{ model: CapabilityListModel }>()
const data = {
  title: props.model.elements.title.value,
  capabilities: pageStore.getListAs<CapabilitiesPageModel>(props.model?.elements.capabilities.value)
}

const openCapability = (item: CapabilitiesPageModel) => {
  pageStore.getUrlByItemId(item.system.id).then(async (url) => {
    if (url) await navigateTo(url, { external: url == '/manatt-ventures' })
  })
}

const removeSplitMobileMargin = inject('removeSplitMobileMargin') as () => void
if (removeSplitMobileMargin && (!data.title || data.title.length == 0)) {
  removeSplitMobileMargin()
}
</script>
